import { render, staticRenderFns } from "./indexedNav.vue?vue&type=template&id=4550939a"
import script from "./indexedNav.vue?vue&type=script&lang=js"
export * from "./indexedNav.vue?vue&type=script&lang=js"
import style0 from "./indexedNav.vue?vue&type=style&index=0&id=4550939a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports